import { Box } from '@mui/material';
import React, { FC } from 'react';
import ReportsResults from './Results';
import ReportsFilters from './Controls';

const ReportsContent: FC = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <ReportsFilters />
      <ReportsResults />
    </Box>
  );
};

export default ReportsContent;
